import { Button } from '../../../../components'
import type { StaffLeaveRequest } from '../types/hrmsLeaveRequests.types'
import { LeaveFilters } from './LeaveFilters'
import { LeaveRequestsTable } from './LeaveRequestsTable'

interface LeaveRequestsCardProps {
  requests: StaffLeaveRequest[]
  typeFilter: string
  onTypeFilterChange: (val: string) => void
  statusFilter: string
  onStatusFilterChange: (val: string) => void
  fromDate: string
  onFromDateChange: (val: string) => void
  toDate: string
  onToDateChange: (val: string) => void
  onClearFilters: () => void
  onViewBalanceHistory: () => void
  onReviewLeave: (id: string) => void
  onViewLeave: (id: string) => void
  page?: number
  limit?: number
  total?: number
  onPageChange?: (page: number) => void
  typeOptions?: Array<{ label: string; value: string }>
}

export function LeaveRequestsCard({
  requests,
  typeFilter,
  onTypeFilterChange,
  statusFilter,
  onStatusFilterChange,
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  onClearFilters,
  onViewBalanceHistory,
  onReviewLeave,
  onViewLeave,
  page,
  limit,
  total,
  onPageChange,
  typeOptions,
}: LeaveRequestsCardProps) {
  return (
    <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-xs space-y-5 min-w-0 font-sans">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 min-w-0">
        <div className="min-w-0">
          <h2 className="text-lg font-bold text-slate-900">Leave Requests</h2>
          <p className="text-sm text-slate-500 mt-0.5">
            Review and manage employee leave requests.
          </p>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={onViewBalanceHistory}
          className="shrink-0 self-start sm:self-auto border-none bg-transparent hover:bg-slate-100 text-[#146971] p-0 font-semibold text-sm"
        >
          View Balance History →
        </Button>
      </div>

      <div className="min-w-0">
        <LeaveFilters
          typeFilter={typeFilter}
          onTypeFilterChange={onTypeFilterChange}
          statusFilter={statusFilter}
          onStatusFilterChange={onStatusFilterChange}
          fromDate={fromDate}
          onFromDateChange={onFromDateChange}
          toDate={toDate}
          onToDateChange={onToDateChange}
          onClearFilters={onClearFilters}
          typeOptions={typeOptions}
        />
      </div>

      <div className="min-w-0">
        <LeaveRequestsTable
          requests={requests}
          onReviewLeave={onReviewLeave}
          onViewLeave={onViewLeave}
          page={page}
          limit={limit}
          total={total}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}
